module.exports = __webpack_public_path__ + "images/earnPointCard1_2e371d5.svg";